import LoginPage from '../pages/LoginPage.vue'
import SigninPage from '../pages/SigninPage.vue'
const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),

    children: [
      {
        path: '',
        component: () => import('pages/Index.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: 'dashboard',
        alias: 'Dashboard',
        component: () => import('pages/Dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'download',
        component: () => import('pages/Catalogo.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'view_search/:id',
        component: () => import('pages/CaricaRicerca.vue'),
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'ricerca',
        component: () => import('pages/Ricerca.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'signin',
        name: 'signin',
        component: SigninPage,
        meta: { requiresAuth: false }
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: { requiresAuth: false }
      },
      {
        path: 'logout',
        name: 'logout',
        component: LoginPage,
        meta: { requiresAuth: false }
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
